// extracted by mini-css-extract-plugin
export var iframe = "styles-module--iframe--2585b";
export var loading = "styles-module--loading--f395a";
export var permissions = "styles-module--permissions--9caa6";
export var wrapper = "styles-module--wrapper--5a695";